import { APIS } from "../../utils/APIS";
import { api } from "../api";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: APIS.Auth,
        method: "POST",
        body: data,
      }),
    }),

    profile: builder.query({
      query: () => APIS.Auth,
      providesTags: ["Auth"],
    }),
  }),
});

export const { useLoginMutation, useProfileQuery, useLazyProfileQuery } =
  authApi;
